import { GetIsCrmAllowed } from '@/constants/getters';

export default function ({ route, redirect, store }) {
  if (route.path === '/dashboard/amps') {
    return redirect('/dashboard');
  }

  if (route.path === '/account/crm') {
    if (!store.getters[`authStore/${GetIsCrmAllowed}`]) {
      return redirect('/dashboard');
    }
  }
}
